import { Box, Card, CardContent, Divider, Skeleton, Typography } from "@mui/material";

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
  height?: number;
  rightHeaderContent?: React.ReactNode;
  empty?: boolean;
}

const ChartCard = ({ title, children, loading, empty, height = 200, rightHeaderContent }: ChartCardProps) => {
  const renderContent = () => {
    if (loading) {
      return <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />;
    }

    if (empty) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      );
    }

    return children;
  };

  return (
    <Card>
      <CardContent sx={{ backgroundColor: (theme) => theme.palette.general.backgroundDark, borderRadius: "inherit" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Typography variant="h4" fontWeight={500}>
            {title}
          </Typography>
          {rightHeaderContent && <Box mt={{ xs: 1, sm: 0 }}>{rightHeaderContent}</Box>}
        </Box>
      </CardContent>
      <Divider />
      <CardContent
        sx={{
          height,
        }}
      >
        {renderContent()}
      </CardContent>
    </Card>
  );
};

export default ChartCard;
